import React, { useEffect, useRef } from 'react';
import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';
import { Grid, Button, Note } from '@inplayer-org/inplayer-ui';

// components
import PanoptoForm from 'pages/MerchantPages/Assets/Content/components/FormikFields/Panopto/PanoptoForm';
import StyledContainer from 'components/StyledContainer';

// hooks
import useIframe from 'hooks/useIframe';

// actions
import {
  loadSessionChooser as loadSessionChooserAction,
  clearPanoptoContent as clearPanoptoContentAction,
} from 'ducks/merchantDucks/items/actions';

// types
import RootState from 'ducks/RootState';

const { Cell } = Grid;

const StyledNote = styled(Note)`
  margin-right: 20px;
  margin-bottom: 1rem;
`;

type PanoptoContentObject = Record<string, any>;

interface StateProps {
  formdata: {
    isFetchingFormData: boolean;
    isFormDataFetched: boolean;
    formValues: PanoptoContentObject;
    formAction: string;
  };
  selectedContent: PanoptoContentObject;
}

interface DispatchProps {
  loadSessionChooser: () => void;
  clearSelectedContent: () => void;
}

interface OwnProps {
  setValue: (panoptoContent: PanoptoContentObject) => void;
}

type Props = StateProps & DispatchProps & OwnProps;

const VideoMenu = ({
  formdata: { isFetchingFormData, isFormDataFetched, formAction, formValues },
  selectedContent,
  loadSessionChooser,
  clearSelectedContent,
  setValue,
}: Props) => {
  const formRef = useRef<HTMLFormElement>(null);

  const { isLoading, startLoading, onLoad } = useIframe([isFormDataFetched]);

  useEffect(() => {
    if (!isFetchingFormData && !isFormDataFetched) {
      loadSessionChooser();
    }
  }, []);

  useEffect(() => {
    if (!isFormDataFetched) {
      return;
    }

    const { current: form } = formRef;

    if (form) {
      startLoading();
      form.submit();
    }
  }, [isFormDataFetched]);

  useEffect(() => {
    if (!isEmpty(selectedContent)) {
      setValue(selectedContent);
    }
  }, [selectedContent]);

  const returnToVideoBrowsing = () => {
    const { current: form } = formRef;

    if (form) {
      clearSelectedContent();
      form.submit();
    }
  };

  return (
    <>
      {!isEmpty(selectedContent) ? (
        <StyledContainer margin="0 0 1rem 0" columns={1}>
          <Cell>
            <Button type="button" onClick={returnToVideoBrowsing}>
              Choose another video...
            </Button>
          </Cell>
        </StyledContainer>
      ) : (
        <StyledNote
          type="warning"
          title="Important!"
          text='Please click the "Insert" button below, before clicking "Save".'
        />
      )}
      <PanoptoForm formRef={formRef} isLoading={isLoading} action={formAction} formdata={formValues} onLoad={onLoad} />
    </>
  );
};

export const mapStateToProps: MapStateToProps<StateProps, OwnProps, RootState> = (state) => ({
  formdata: {
    isFetchingFormData: state.items.isFetchingFormData,
    isFormDataFetched: state.items.isFormDataFetched,
    formValues: state.items.formdata,
    formAction: state.items.launch_url,
  },
  selectedContent: state.items.panoptoContent,
});

export const mapActionsToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  loadSessionChooser: loadSessionChooserAction,
  clearSelectedContent: clearPanoptoContentAction,
};

export default connect(mapStateToProps, mapActionsToProps)(VideoMenu);
